import { Group } from '@/router/group.model';
import { home } from '@/router/routes';

const routes = [home];

const homeGroup = new Group('Home', 'home', routes, {
  superRoot: false
});

export { homeGroup };
export default homeGroup;
